import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import touch from 'vue3-hand-mobile';
import { VueMasonryPlugin } from 'vue-masonry';
// import AMapLoader from '@amap/amap-jsapi-loader';

import { Locale, Popup, Button, Image, Icon, Field, Picker, ImagePreview, Toast as VanToast, Lazyload, Switch, Dialog } from 'vant';
// import 'vant/lib/index.css';
import 'vant/es/toast/style';
import 'vant/es/image-preview/style';
import 'vant/es/notify/style';
import 'vant/es/dialog/style';

import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/zh-cn';
import Validator from 'async-validator';

import 'vue2-animate/dist/vue2-animate.min.css';

// import { VueError, useData } from './logger';
import { messages } from './i18n';

import App from './App.vue';
import router from './router';
import store from './store';

import Components from './components/index';
import Mixins from './mixins';
import http from './api/http/index';
import httpArea from './api/http/httpArea';

import './icons/index';
import { parseQuery } from './utils';
import { APP_LANGS } from './constants';

import './utils/rem';
import './assets/stylesheet/reset.css';
import { instanceComposable } from './composables';
import getLanguage from '@/utils/setLanguage';

// audio对象，挂载在Vue对象和组件上，配合WeixinJSBridgeReady事件，实现自动播放

// // 输出中英文翻译
// const enArrays = parseObjectValue(messages.en).filter((val) => val);
// const zhArrays = parseObjectValue(messages.zh).filter((val) => val);
// const newArrayValues = zhArrays.map((element) => {
//   const [key, value] = `${element}`.split(':').map((val) => val.trim());
//   const enValue = enArrays.filter((itemValue) => itemValue.split(':')[0] === key)[0];
//   const newValue = enValue && enValue.split(':')[1];
//   return `${value}: ${newValue || '----'}`;
// });

// const zhKeys = [...new Set(newArrayValues.map((val) => val.split(':')[0].trim()))];
// const zhFilterArrays = zhKeys.map((key) => newArrayValues.filter((val) => val.split(':')[0].trim() === key)[0]);

// console.log(enArrays);
// console.log(zhArrays);
// console.log(JSON.stringify(newArrayValues));
// console.log(JSON.stringify(zhFilterArrays));

// AMapLoader.load({
//   key: AMAP_AK, // 申请好的Web端开发者Key，首次调用 load 时必填
//   version: '2.0', // 指定要加载的 JS API 的版本，缺省时默认为 1.4.15
//   plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
// });
if (window.VConsole) {
  const vConsole = new window.VConsole({ maxLogNumber: 1000 });
  console.log(vConsole);
}

console.log(store);
dayjs.locale();
let { queryLocale, navigatorLanguage } = getLanguage(parseQuery(window.location.href).locale);
const language = queryLocale || JSON.parse(window.localStorage.getItem('language')) || navigatorLanguage;
const locale = APP_LANGS[language] || APP_LANGS['en'];
console.log(locale);
Locale.use(locale, messages[locale]);
localStorage.setItem('language', JSON.stringify(locale));
const i18n = createI18n({ mode: 'composition', locale, fallbackLocale: locale, messages });
function setLocale(newValue) {
  i18n.global.locale = newValue;
  i18n.global.fallbackLocale = newValue;
  app.config.globalProperties.lang = newValue;
  localStorage.setItem('language', JSON.stringify(newValue));
  Locale.use(newValue, messages[newValue]);
}

instanceComposable.useI18n(i18n);

http.useRouter(router).useStore(store).useI18n(i18n);
httpArea.useRouter(router).useStore(store).useI18n(i18n);

const app = createApp(App);

window.app = app;
app.config.globalProperties.productionTip = false;
app.config.globalProperties.$dayjs = dayjs;
app.config.globalProperties.$Validator = Validator;
app.config.globalProperties.$audio = new Audio();
app.config.globalProperties.lang = locale;
app.config.globalProperties.i18n = i18n;
app.config.globalProperties.setLocale = setLocale;
app.setLocale = setLocale;
app.$i18n = i18n;
// app.use(VueError);
app.use(i18n);
app.use(touch);
app.use(Mixins);
app.use(Components);
app.use(VueMasonryPlugin);
app.use(Popup).use(Button).use(Image).use(Icon).use(Field).use(Picker).use(Lazyload).use(ImagePreview).use(VanToast).use(Switch).use(Dialog);

const token = parseQuery(window.location.search).token;
if ((app.isMiniapp || app.isApp) && (!token || /null/.test(token))) {
  localStorage.removeItem('token');
}

app.use(store).use(router).mount('#app');

instanceComposable.useApp(app);
